import React from "react";
import styled from "styled-components";
import { MainLayout } from "../styles/Layouts";
import SectionTitle from "../Components/SectionTitle";
import ImageSection from "../Components/ImageSection";
import ServicesSection from "../Components/ServicesSection";
import Skills from "../Components/Skills";
import { PageTransition, FadeIn } from "../Components/AnimatedComponents";

const AboutPage: React.FC = () => {
  return (
    <PageTransition>
      <MainLayout>
        <AboutStyled>
          <FadeIn direction="up">
            <SectionTitle title={"About Me"} span={"about"} />
          </FadeIn>
          <FadeIn direction="up" delay={0.1}>
            <ImageSection />
          </FadeIn>
          <div className="spacer" />
          <FadeIn direction="up" delay={0.15}>
            <ServicesSection />
          </FadeIn>
          <FadeIn direction="up" delay={0.2}>
            <Skills />
          </FadeIn>
        </AboutStyled>
      </MainLayout>
    </PageTransition>
  );
};

const AboutStyled = styled.section`
  .spacer {
    height: 2rem;
  }
`;

export default AboutPage;
